const localStorageService = {
    getItem: (key) => {
        if (!localStorage || !key) {
            return null;
        }
        return localStorage.getItem(key);
    },
    setItem: (key, value) => {
        if (!localStorage || !key || value === null) {
            return false;
        }
        localStorage.setItem(key, value);
        return true;
    },
    removeItem: (key) => {
        if (!localStorage || !key) {
            return false;
        }
        localStorage.removeItem(key);
        return true;
    },
};
export default localStorageService;
